(function () {
  if (window.__intlAckLoaded) return;
  window.__intlAckLoaded = true;

  var DYNAMIC_BTN_SELECTOR = '.additional-checkout-buttons, [data-shopify="dynamic-checkout"]';
  var CART_SCOPES = '[data-cart-form], .cart__buttons-wrapper, [data-section-type="cart-drawer"], [data-section-type="cart"]';
  var ATTR_KEY = 'International Order Acknowledged';
  var ERROR_TEXT = 'Please tick the box to confirm you have read the international orders information before continuing.';

  if (window.theme && window.theme.strings) {
    window.theme.strings.cartAcceptanceError = ERROR_TEXT;
  }

  function isInternational() {
    return !!document.querySelector('[data-intl-ack][data-international="true"]');
  }

  function isAcknowledged() {
    var cb = document.querySelector('[data-intl-ack-checkbox]');
    return !!(cb && cb.checked);
  }

  function writeCartAttribute(value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR_KEY]: value } })
    }).catch(function () {});
  }

  function syncDynamicButtons() {
    if (!isInternational()) return;
    var blocked = !isAcknowledged();
    document.querySelectorAll(CART_SCOPES).forEach(function (scope) {
      scope.querySelectorAll(DYNAMIC_BTN_SELECTOR).forEach(function (el) {
        el.style.display = blocked ? 'none' : '';
      });
    });
  }

  function syncCheckboxes(source) {
    var checked = source.checked;
    document.querySelectorAll('[data-intl-ack-checkbox]').forEach(function (cb) {
      if (cb !== source && cb.checked !== checked) {
        cb.checked = checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function flashPanel() {
    var panels = document.querySelectorAll('[data-intl-ack]');
    if (!panels.length) return;
    panels.forEach(function (panel) {
      panel.classList.add('intl-ack--error');
      setTimeout(function () { panel.classList.remove('intl-ack--error'); }, 600);
    });
    var visible = Array.prototype.find.call(panels, function (p) {
      return p.offsetParent !== null;
    }) || panels[0];
    visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var scope = visible.closest(CART_SCOPES) || document;
    var cb = scope.querySelector('[data-intl-ack-checkbox]') || document.querySelector('[data-intl-ack-checkbox]');
    if (cb) cb.focus();
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-intl-ack-checkbox]')) return;
    syncCheckboxes(e.target);
    writeCartAttribute(e.target.checked ? 'Yes' : '');
    syncDynamicButtons();
  });

  document.addEventListener('click', function (e) {
    if (!isInternational() || isAcknowledged()) return;
    var btn = e.target.closest('[name="checkout"], .cart__checkout, [data-shopify="dynamic-checkout"] *');
    if (!btn) return;
    if (!btn.closest(CART_SCOPES)) return;
    flashPanel();
  }, true);

  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (!submitter || !submitter.matches('[name="checkout"], .cart__checkout')) return;
    if (isInternational() && !isAcknowledged()) flashPanel();
  }, true);

  ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added'].forEach(function (ev) {
    document.addEventListener(ev, syncDynamicButtons);
  });
  var cartRoot = document.querySelector('cart-drawer, #cart-drawer, .cart, [data-section-type="cart-drawer"]') || document.body;
  new MutationObserver(syncDynamicButtons).observe(cartRoot, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDynamicButtons);
  } else {
    syncDynamicButtons();
  }
})();
